import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Layout, Modal, Spinner } from '@vwfs-bronson/bronson-react';
import { loadingSelectors } from '../../../../services/redux/features/loading.slice';

export const StakeholderRemovalModal: React.FC<any> = ({ onAbort, onConfirm, shown, isSignatory }) => {
  const { t } = useTranslation();
  const isLoading = useSelector(loadingSelectors.selectIsRenderingLocalSpinner);

  const renderLoader = () => (
    <Layout>
      <Layout.Item>
        <Spinner small center />
      </Layout.Item>
    </Layout>
  );

  const renderContent = () => (
    <Layout>
      <Layout.Item className="u-text-center">
        {isSignatory ? t(`step4:removeSignatoryPrompt`) : t('step4:removeDirectorPrompt')}
      </Layout.Item>
    </Layout>
  );

  return (
    <Modal
      center
      title={isSignatory ? t(`step4:removeSignatoryTitle`) : t(`step4:removeDirectorTitle`)}
      shown={shown}
      buttonConfirmLabel={t(`step4:stakeholderSection:buttons:remove`)}
      buttonCancelLabel={t(`step4:stakeholderSection:buttons:cancel`)}
      buttonCancelText={t(`step4:stakeholderSection:buttons:cancel`)}
      buttonConfirmText={t(`step4:stakeholderSection:buttons:remove`)}
      onCancel={onAbort}
      onAbort={onAbort}
      onClose={onAbort}
      onConfirm={onConfirm}
      confirmationDisabled={isLoading}
    >
      {isLoading ? renderLoader() : renderContent()}
    </Modal>
  );
};
